import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createSlots as _createSlots, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "form-block" }
const _hoisted_2 = { class: "label-block" }
const _hoisted_3 = { class: "label-block_label" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "label-block_question position-relative"
}
const _hoisted_6 = { class: "tooltip-content" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  class: "popper",
  "data-bs-trigger": "hover",
  placement: "right",
  "data-bs-toggle": "popover"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "icon-question-icon" })
  ])
], -1)
const _hoisted_8 = { class: "input-block" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "row-input" }
const _hoisted_11 = { class: "row gx-20" }
const _hoisted_12 = { class: "col-sm-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_calendar = _resolveComponent("calendar")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", null, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (_ctx.isRequired)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "*"))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.isTooltip)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_el_tooltip, {
              class: "box-item",
              effect: "light"
            }, {
              content: _withCtx(() => [
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.tooltipMessage), 1)
              ]),
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.colSize)
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_el_form_item, {
                  prop: _ctx.dayProp,
                  rules: _ctx.rules
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "tel",
                      placeholder: "DD/MM/YYYY",
                      modelValue: _ctx.firstDate,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.firstDate) = $event)),
                      onInput: _ctx.updateValue,
                      onChange: _ctx.changeValue,
                      maxlength: "10",
                      pattern: "[0-9]*",
                      disabled: _ctx.disabled,
                      ref: "inputRef",
                      size: "large",
                      onKeydown: _withKeys(_ctx.closeCalendar, ["enter"])
                    }, _createSlots({ _: 2 }, [
                      (_ctx.language == 'ar')
                        ? {
                            name: "prefix",
                            fn: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                style: {"visibility":"hidden","width":"1px","margin-right":"120px"},
                                modelValue: _ctx.firstDate,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstDate) = $event)),
                                type: "date",
                                placeholder: _ctx.placeHolder,
                                format: "YYYY/MM/DD",
                                "value-format": "DD/MM/YYYY",
                                "disabled-date": _ctx.disabledDate,
                                ref: "calRef",
                                "default-value": _ctx.defaultValue,
                                clearable: false,
                                onChange: _ctx.changeValue,
                                class: "classmate",
                                disabled: _ctx.disabled
                              }, null, 8, ["modelValue", "placeholder", "disabled-date", "default-value", "onChange", "disabled"]),
                              _createVNode(_component_el_icon, {
                                class: "el-input__icon pointer",
                                onClick: _ctx.openCalendar
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_calendar)
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            key: "0"
                          }
                        : {
                            name: "suffix",
                            fn: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                style: {"visibility":"hidden","width":"1px","margin-right":"120px"},
                                modelValue: _ctx.firstDate,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.firstDate) = $event)),
                                type: "date",
                                placeholder: _ctx.placeHolder,
                                format: "YYYY/MM/DD",
                                "value-format": "DD/MM/YYYY",
                                "disabled-date": _ctx.disabledDate,
                                ref: "calRef",
                                "default-value": _ctx.defaultValue,
                                clearable: false,
                                onChange: _ctx.changeValue,
                                class: "classmate",
                                disabled: _ctx.disabled
                              }, null, 8, ["modelValue", "placeholder", "disabled-date", "default-value", "onChange", "disabled"]),
                              _createVNode(_component_el_icon, {
                                class: "el-input__icon pointer",
                                onClick: _ctx.openCalendar
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_calendar)
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            key: "1"
                          }
                    ]), 1032, ["modelValue", "onInput", "onChange", "disabled", "onKeydown"])
                  ]),
                  _: 1
                }, 8, ["prop", "rules"])
              ]),
              _createVNode(_component_el_form_item, { prop: _ctx.formProp }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "hidden",
                    "model-value": _ctx.modelValue
                  }, null, 8, ["model-value"])
                ]),
                _: 1
              }, 8, ["prop"]),
              _createVNode(_component_el_form_item, {
                prop: `${_ctx.formProp}_label`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, { type: "hidden" })
                ]),
                _: 1
              }, 8, ["prop"])
            ])
          ])
        ], 2)
      ])
    ])
  ]))
}